import { render, staticRenderFns } from "./tab-waiting.vue?vue&type=template&id=5d198a1c&scoped=true"
import script from "./tab-waiting.vue?vue&type=script&lang=js"
export * from "./tab-waiting.vue?vue&type=script&lang=js"
import style0 from "./tab-waiting.vue?vue&type=style&index=0&id=5d198a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d198a1c",
  null
  
)

export default component.exports